import { Operation } from 'apollo-boost';
import { GraphQLError } from 'graphql';
import { ErrorDetail, NormalizedError } from './types';

const REQUEST_ID_HEADER = 'X-Request-ID';

export const normalizeGraphQLError = (error: GraphQLError, operation: Operation): NormalizedError => {
	const context = operation?.getContext?.();

	const headers: Headers | undefined = context?.response?.headers;
	const requestId = headers.get(REQUEST_ID_HEADER);

	const details: ErrorDetail[] = [];

	if (operation?.operationName) {
		details.push({ label: 'Operation name', value: operation.operationName });
	}

	if (requestId) {
		details.push({ label: 'X-Request-ID', value: requestId });
	}

	if (error?.message) {
		details.push({ label: 'Error text', value: error.message });
	}

	return { details };
};
